{
  "version": 1,
  "asset_id": "c647835c-4027-4dd4-8da3-62ba52fe7eb1",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/c647835c-4027-4dd4-8da3-62ba52fe7eb1/bahcesehir-hizli-elektrikci-7-24-dukkan-4.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/c647835c-4027-4dd4-8da3-62ba52fe7eb1/bahcesehir-hizli-elektrikci-7-24-dukkan-4.jpg",
  "original_filename": "bahcesehir-hizli-elektrikci-7-24-dukkan-4.jpg",
  "size": 486461,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T16:18:48Z"
}
